module.exports = __webpack_public_path__ + "static/media/droplet.8a6ea55d.png";